import React from 'react';
import { PublicGicLandingPage } from '@applyboard/ab-vas-gic';

export default function GicLandingPage() {
  return <PublicGicLandingPage />;
}
